import React from "react";
import PropTypes from "prop-types";
import { Typography, Box } from "@material-ui/core";
import { COLORS, SPACING, APPLY_MODES } from "../constants";
import { SectionHeading } from "./UI";
import { useStyles } from "../views/wizard-view.style";

export function WizardModeStep({ wizardMode, setWizardMode }) {
  const classes = useStyles();
  return (
    <Box>
      <SectionHeading>Apply Mode</SectionHeading>
      <Typography variant="body2" sx={{ color: COLORS.muted, marginBottom: `${SPACING.detailGap}px` }}>
        Overlapping configurations detected. Choose how to handle them.
      </Typography>
      {APPLY_MODES.map((mode) => {
        const isSelected = wizardMode === mode.id;
        return (
          <Box
            component="button"
            type="button"
            key={mode.id}
            onClick={() => setWizardMode(mode.id)}
            className={classes.modeOption}
            sx={{
              background: isSelected ? COLORS.primaryLight : COLORS.white,
              border: `2px solid ${isSelected ? COLORS.primary : COLORS.border}`,
            }}
          >
            <Box
              className={classes.radioCircle}
              sx={{ border: `2px solid ${isSelected ? COLORS.primary : COLORS.border}`, marginTop: '2px' }}
            >
              {isSelected && <Box className={classes.radioFill} />}
            </Box>
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600, color: COLORS.body }}>
                {mode.title}
              </Typography>
              <Typography variant="caption" sx={{ color: COLORS.muted, marginTop: '2px', lineHeight: 1.4, display: 'block' }}>
                {mode.description}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

WizardModeStep.propTypes = {
  wizardMode: PropTypes.string,
  setWizardMode: PropTypes.func.isRequired,
};

WizardModeStep.defaultProps = {
  wizardMode: "merge",
};
